//Parroquias Lara
const munAndrésEloyBlanco = [
  'Pío Tamayo',
  'Quebrada Honda De Guache',
  'Yacambú',
];
const munCrespo = ['Fréitez', 'José María Blanco'];
const munIribarren = [
  'Catedral',
  'Concepción',
  'El Cují ',
  'Juan De Villegas',
  'Santa Rosa',
  'Tamaca',
  'Unión',
  'Aguedo Felipe Alvarado',
  'Buena Vista',
  'Juárez ',
];
const munJiménez = [
  'Juan Bautista Rodríguez',
  'Cuara',
  'Diego De Lozada',
  'Paraíso De San José ',
  'San Miguel',
  'Tintorero',
  'Cabo José Bernardo Dorante',
  'Coronel Mariano Peraza',
];
const munMorán = [
  'Bolívar',
  'Anzoátegui',
  'Guárico',
  'Hilario Luna Y Luna',
  'Humocaro Alto',
  'Humocaro Bajo',
  'La Candelaria',
  'Morán',
];
const munPalavecino = ['Cabudare', 'José Gregorio Bastidas', 'Agua Viva'];
const munSimónPlanas = ['Sarare', 'Buría', 'Gustavo Vegas León'];
const munTorres = [
  'Trinidad Samuel',
  'Antonio Díaz',
  'Camacaro',
  'Castañeda',
  'Cecilio Zubillaga',
  'Chiquinquirá',
  'El Blanco',
  'Espinoza De  Los Monteros',
  'Lara',
  'Las Mercedes',
  'Manuel Morillo',
  'Montaña Verde',
  'Montes De Oca',
  'Torres',
  'Heriberto Arroyo',
  'Reyes Vargas',
  'Altagracia',
];
const munUrdanetaLara = ['Siquisique', 'Moroturo', 'San Miguel', 'Xaguas'];
export const esLara = [
  {
    municipio: 'Andres Eloy Blanco',
    parroquias: munAndrésEloyBlanco,
  },
  {
    municipio: 'Crespo',
    parroquias: munCrespo,
  },
  {
    municipio: 'Iribarren',
    parroquias: munIribarren,
  },
  {
    municipio: 'Jiménez',
    parroquias: munJiménez,
  },
  {
    municipio: 'Morán',
    parroquias: munMorán,
  },
  {
    municipio: 'Palavecino',
    parroquias: munPalavecino,
  },
  {
    municipio: 'Palavecino',
    parroquias: munSimónPlanas,
  },
  {
    municipio: 'Palavecino',
    parroquias: munTorres,
  },
  {
    municipio: 'Palavecino',
    parroquias: munUrdanetaLara,
  },
];
